import { render } from "./FieldsSelect.vue?vue&type=template&id=624a0a1a"
import script from "./FieldsSelect.vue?vue&type=script&lang=js"
export * from "./FieldsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__